const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminApprovalSuccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    d: "M-.5-.5h320v320H-.5z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M147.5 23.5q6.755 0 13 2.5a90 90 0 0 0-15 0 17.34 17.34 0 0 0-7 3.5q-1.19-1.283 1-2.5a102 102 0 0 0 8-3.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M93.5 25.5a266 266 0 0 1 18.5 10q-.305 4.611-4 8-3.052-5.038-7-1-1.248 5.465 4.5 5-1.958 11.37-11 4-1.513 5.23-7 4-.51-3.966 2-7a30 30 0 0 1-6-4.5 482 482 0 0 1 10-18.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be725f",
    d: "M119.5 86.5v1q.915 1.337 1 3a57.5 57.5 0 0 1 1.5 13 42.7 42.7 0 0 1-9 14q-1.513 2.288-1.5 5h-3q-5.631-1.992-3.5-8a9.5 9.5 0 0 1 1.5-2.5l-1-.5a47.9 47.9 0 0 1-14 9q-3.965-.965-5-5-8.43 3.83-8-5h-5q-2.439-8.11 6-10 1.63-.18 2-2a87 87 0 0 1-2-9h-9q-1.998 16.97-2 35 .002 18.03 2 35 14.771-.49 29 1h-32v-72h-4q-14.425-.921-18-15a279 279 0 0 1-31-24 195.4 195.4 0 0 1 23-24 1175 1175 0 0 1 28 29.5q24.12 9.206 48 19l2.5 2.5a56.5 56.5 0 0 0 3.5 10",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccd",
    d: "M170.5 34.5q8.32 10.527 2.5 23 1.97-11.865-2.5-23",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9cccc",
    d: "M131.5 34.5q.814.09 1 1-3.502 5.76-3 12.5.488 4.82.5 9.5-5.478-11.94 1.5-23",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdc09e",
    d: "M224.5 109.5h-1a10.1 10.1 0 0 0-6 1.5l-8 8q-4.006 1.25-7-1.5-.06-4.387 2.5-8a115 115 0 0 0 17-19q.29-5.302-5.5-5 1.647-1.345 0-2.5a25 25 0 0 0-7-.5q-8.121-2.549-15 2v1h-19a141 141 0 0 1 7.5-14 170 170 0 0 1 13.5-7.5q25.603-.602 50 7 4.5 1 9 0 17.812-13.83 35.5-27.5a177.5 177.5 0 0 1 17.5 31 5675 5675 0 0 0-53 23.5 1256 1256 0 0 1-31 11.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f07b68",
    d: "M159.5 38.5q3.752.489 3.5 4A126 126 0 0 1 150.5 56q-1.5 1-3 0a109 109 0 0 0-7.5-6.5q-.463-2.837 2.5-4a10.5 10.5 0 0 1 5 3.5q1.5 1 3 0a73 73 0 0 0 9-10.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdf9f3",
    d: "M209.5 82.5q1.144 1.152 3 1.5-8.986.75-18 .5 6.879-4.549 15-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd7ca",
    d: "M209.5 82.5q3.535-.245 7 .5 1.647 1.155 0 2.5h-22v-1q9.014.25 18-.5-1.856-.348-3-1.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa705a",
    d: "M147.5 85.5h64q3.963.904 7 4a399 399 0 0 1-14.5 19q-3.432 4.355-1.5 9 2.994 2.75 7 1.5l8-8a10.1 10.1 0 0 1 6-1.5v48h-27q5.712-9.235.5-19-1.693-2.462-4.5-3-8.521-4.87-14 3.5.343.598 1 .5-9.244 6.705-4 17-13.728 1.49-28 1v-30h-4v3q-5.757-.717-10 3-4.077-.906-7-4a37.3 37.3 0 0 1-.5-14q5.854-5.946 11.5.5l4 .5q2.75-.128 4-2 .925-.166 1.5-1 .75-13.99.5-28",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9492f",
    d: "M119.5 87.5h25v3h-24a5.73 5.73 0 0 0-1-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9543f",
    d: "M211.5 85.5h5q5.79-.302 5.5 5a115 115 0 0 1-17 19q-2.56 3.613-2.5 8-1.932-4.645 1.5-9a399 399 0 0 0 14.5-19q-3.037-3.096-7-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c8c3",
    d: "M147.5 85.5q.25 14.01-.5 28-.575.834-1.5 1 .49-13.773-1-27h-25v-1q14.125.458 28-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M273.5 106.5q12.102-.853 10.5 11a17.8 17.8 0 0 1-4.5 5.5 46 46 0 0 0 17 4.5 25 25 0 0 1-.5 7 614 614 0 0 0-10 38q-.99 4.736-5.5 6l-45-12-1-2.5a167 167 0 0 0 5-19.5q4.764 3.64 11 5 10.056-2.109 6-12l-2-2q-5.957-1.584-12 0l5-20a232 232 0 0 1 20.5 5l1.5-1q-3.417-8.434 4-13",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb4f40",
    d: "M144.5 87.5q1.49 13.227 1 27-1.25 1.872-4 2l-4-.5q-5.646-6.446-11.5-.5-1.075 7.08.5 14-2.51-1.264-3.5-4l-1-7q-4.729 10.274 5.5 15.5 3.147 1.017 6-.5 4.243-3.717 10-3h1q1.49 14.228 1 29h-29v4q0 1 1 1 8.085 13.643-6 20-5.158.37-10-1v-1q-3.129-4.14-3-9.5 1.047-6.705 4-12.5h-3q-14.229-1.49-29-1v-70h3a46 46 0 0 0 5.5 6q.74 2.45.5 5-8.439 1.89-6 10-.814.09-1 1l4 2q2.703 6.544 10 5.5a13.9 13.9 0 0 1 3 4q6.684-.078 12-4.5.428 4.836 5 6 1.82-.37 2-2h3q-.013-2.712 1.5-5a42.7 42.7 0 0 0 9-14 57.5 57.5 0 0 0-1.5-13h24z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#903a29",
    d: "M73.5 89.5h6a87 87 0 0 0 2 9q-.37 1.82-2 2 .24-2.55-.5-5a46 46 0 0 1-5.5-6",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923728",
    d: "M73.5 110.5h5q-.43 8.83 8 5 1.035 4.035 5 5a47.9 47.9 0 0 0 14-9l1 .5a9.5 9.5 0 0 0-1.5 2.5q-2.131 6.008 3.5 8-.18 1.63-2 2-4.571-1.164-5-6-5.316 4.422-12 4.5a13.9 13.9 0 0 0-3-4q-7.297 1.044-10-5.5l-4-2q.186-.91 1-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecebea",
    d: "M63.5 88.5h4v72h32v3h-34a422 422 0 0 0-2.5 21A309 309 0 0 1 37.5 198q-2.5 1-5 0a1003 1003 0 0 1-23-46.5 134 134 0 0 0 20-9q1.5.5 2 2-3.123 7.467 4 11.5 13.824 1.165 10.5-12.5a15.8 15.8 0 0 0-5.5-3.5q-1.425-1.077-.5-2.5 8.474-4.496 17-9 5.558 6.573 9 15 .75-26.995.5-54-1.936.356-3-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6ca",
    d: "M126.5 129.5q2.923 3.094 7 4-2.853 1.517-6 .5-10.229-5.226-5.5-15.5l1 7q.99 2.736 3.5 4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf918c",
    d: "M147.5 157.5q-1-14.262-2-29-1.197.686-1 2h-1v-3h4z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fde8de",
    d: "M192.5 135.5q3.4 2.8 3.5 7a11.53 11.53 0 0 0-4.5-3.5 28.2 28.2 0 0 0-12 .5q-.657.098-1-.5 5.479-8.37 14-3.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1382a",
    d: "M70.5 89.5v70q-1.998-16.97-2-35 .002-18.03 2-35",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e89f91",
    d: "M175.5 156.5q1.5.5 2 2-15.272.49-30-1 14.272.49 28-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c8bf",
    d: "M223.5 109.5h1v50h-29v3q14.272-.49 28 1h-29q-.712-3.873 2-6h27z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faede9",
    d: "M147.5 157.5q14.728 1.49 30 1v4h-31l-2 1h-28v-4h29q.49-14.772-1-29-.197-1.314 1-2 1 14.738 2 29",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb4e3f",
    d: "M192.5 135.5q2.807.538 4.5 3 5.212 9.765-.5 19-2.712 2.127-2 6h29v26a70 70 0 0 1-6-6.5q-6.625-2.352-6 4.5-.814.09-1 1a329 329 0 0 0 13 27v13h-2q-9.83-4.08-21-5-2.4.076-4.5 1a18.5 18.5 0 0 0-.5 6h-45q.25-10.013-.5-20-1.517-1.255-3.5-1 .895-.958 2.5-1 6.354 5.082 14.5 4 10.323-5.78 5.5-17-2.176-2.946-5.5-4h-3q-.353-.895-1.5-1a88 88 0 0 0-9.5 4q-1.839-.03-3-1v-2q2.958-13.41 2-28h30q.426-2.872-1-5-.5-1.5-2-2-5.244-10.295 4-17a28.2 28.2 0 0 1 12-.5 11.53 11.53 0 0 1 4.5 3.5q-.1-4.2-3.5-7",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8968d",
    d: "M177.5 158.5q1.426 2.128 1 5h-32v-1h31z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc725c",
    d: "M65.5 163.5h34q-6.15 7.204-2.5 16 1.694 2.462 4.5 3v1q-.658-.098-1 .5 5.579 6.626 11 .5 14.085-6.357 6-20h26q-.49 14.272 1 28 .513 1.257 2 1 1.161.97 3 1a88 88 0 0 1 9.5-4q1.147.105 1.5 1 8.098 4.72 5.5 14-.52 3.522-3.5 5.5.343.598 1 .5v1q-8.146 1.082-14.5-4-1.605.042-2.5 1-1.494-.129-2.5 1-.75 12.49-.5 25h-19q1.485-11.966.5-24-.912-2.35-2.5-4-3.438-.384-6.5 1a536 536 0 0 0-5 20q-1.36 4.608-5.5 7h-37v-1q4.572.009 1.5-3-.75-33.496-.5-67h-3v68a1191 1191 0 0 1-1-69",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a73c2d",
    d: "M99.5 160.5h3q-2.953 5.795-4 12.5-.129 5.36 3 9.5-2.806-.538-4.5-3-3.65-8.796 2.5-16z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec4bd",
    d: "M146.5 162.5v31q-1.487.257-2-1v-29z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e2b24",
    d: "M146.5 163.5h2q.958 14.59-2 28z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d17360",
    d: "M116.5 163.5h28v29q-1.49-13.728-1-28h-26q-1 0-1-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcdbd3",
    d: "M101.5 183.5q4.842 1.37 10 1-5.421 6.126-11-.5.342-.598 1-.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac5b6",
    d: "M160.5 191.5h3q7.666 7.17 3.5 17a14.7 14.7 0 0 1-3.5 3q-.657.098-1-.5 2.98-1.978 3.5-5.5 2.598-9.28-5.5-14",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de5848",
    d: "M68.5 234.5q-1.5-.5-2-2v-68h3q-.25 33.504.5 67 3.072 3.009-1.5 3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96341f",
    d: "M211.5 187.5a229 229 0 0 1 12 26v2a329 329 0 0 1-13-27q.186-.91 1-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d2c21",
    d: "M163.5 191.5q3.324 1.054 5.5 4 4.823 11.22-5.5 17v-1a14.7 14.7 0 0 0 3.5-3q4.166-9.83-3.5-17",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb9b6b",
    d: "M264.5 208.5a76 76 0 0 1-1 15h3q-.378 13.07 1.5 26 .747 3.067 3.5 4a1188 1188 0 0 1 21 41v3h-37a170 170 0 0 0-8-33 498 498 0 0 0-26-14.5 338 338 0 0 1-17-13.5q0-1-1-1-.513-1.257-2-1 0-1-1-1a19.6 19.6 0 0 0-3.5-4q-1.026-1.926.5-3.5 6.727-1.096 13 1.5 5.24 5.878 13 8 2.647 1.442 6 1a224 224 0 0 0-2.5-17q-.636-3.788-3.5-6a229 229 0 0 0-12-26q-.625-6.852 6-4.5a70 70 0 0 0 6 6.5q23.462 42.384 3.5-2a14.7 14.7 0 0 0-3.5-3v-7q3.147-2.194 6 .5a76 76 0 0 1 6 8.5q8.122.061 13 6.5l6 1a49.7 49.7 0 0 1 10 14.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdedde",
    d: "M223.5 184.5q1.941 1.185 3.5 3 19.962 44.384-3.5 2z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6563f",
    d: "M122.5 207.5q1.588 1.65 2.5 4 .985 12.034-.5 24-2.322-.481-2-3a83.4 83.4 0 0 0 0-25",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faf0e8",
    d: "M223.5 213.5q2.864 2.212 3.5 6a224 224 0 0 1 2.5 17q-3.353.442-6-1v-22",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcbf9c",
    d: "M122.5 207.5a83.4 83.4 0 0 1 0 25q-.936.626-1 2 .37 1.82 2 2 3.882 11.715 2.5 24a172 172 0 0 0-13.5 38 553 553 0 0 1-47-1 929 929 0 0 0 23-33 527 527 0 0 0-15-27q16.579.964 32-2 4.14-2.392 5.5-7a536 536 0 0 1 5-20q3.062-1.384 6.5-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#812b25",
    d: "M146.5 211.5q2.95 11.396 2 24-2.95-11.396-2-24",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M47.5 229.5q3.4-.538 5.5 2a140 140 0 0 1 4 26q-6.135 2.401-12.5 1 3.331-9.162-6-7-2.106 4.355 1 8a27.1 27.1 0 0 1-11 3 32.7 32.7 0 0 0-3-12q-10.161 5.091-7-6a9.86 9.86 0 0 1 6-1 44.8 44.8 0 0 0-1-10 451 451 0 0 0 24-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#903324",
    d: "M210.5 227.5a39.7 39.7 0 0 0 11 1h2v7q-7.76-2.122-13-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf4c3b",
    d: "M146.5 209.5q1.983-.255 3.5 1 .75 9.987.5 20h45a18.5 18.5 0 0 1 .5-6q2.1-.924 4.5-1 11.17.92 21 5a39.7 39.7 0 0 1-11-1q-6.273-2.596-13-1.5-1.526 1.574-.5 3.5a19.6 19.6 0 0 1 3.5 4 333 333 0 0 0-51 0 677 677 0 0 0 52 1q1.487-.257 2 1h-55q.95-12.604-2-24z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d54e38",
    d: "M200.5 233.5q1 0 1 1a677 677 0 0 1-52-1 333 333 0 0 1 51 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0a07a",
    d: "M264.5 208.5q1.083.626 1.5 2a6915 6915 0 0 0 3 37 23.4 23.4 0 0 1 2.5 6q-2.753-.933-3.5-4a150.3 150.3 0 0 1-1.5-26h-3a76 76 0 0 0 1-15",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc8c7b",
    d: "M146.5 209.5v2q-2.952 11.9-2 25h-21q-1.63-.18-2-2 .064-1.374 1-2-.322 2.519 2 3h19q-.25-12.51.5-25 1.006-1.129 2.5-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcbc0",
    d: "M146.5 211.5q-.95 12.604 2 24h55q1 0 1 1h-60q-.952-13.1 2-25",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db7c5f",
    d: "M68.5 235.5h37q-15.421 2.964-32 2a26.3 26.3 0 0 1-5-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M168.5 238.5q3.928-.402 7.5 1l16.5 33q-7.162 5.58-16 8 1.544-11.961-10-9-2.904 4.062-1.5 9a18 18 0 0 0 3.5 2q1.624 1.298.5 3a215 215 0 0 0-12.5 6l-2-1a141 141 0 0 0-7.5-14q-3.83 7.69-11.5 3.5-4.388-5.544 1-10 3.6-.279 7-1.5l-5.5-11q-1.124-1.702.5-3a319 319 0 0 0 30-16",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3c7aa",
    d: "M292.5 294.5q1.337 1.142 2 3-19.741 1.987-39 0h37z",
    style: {
      opacity: 1
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminApprovalSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/admin-approval-success.f3858d32.svg";